module.exports = __webpack_public_path__ + "static/media/authorization2.5f0d5a99.png";